import { LOGOUT } from "@/components/access/ducks/Actions"
import { UPDATE_ADMIN_EMAIL_TYPE } from "@/components/email/admin/ducks/Actions"
import {
  CHANGE_BODY,
  CHANGE_SUBJECT,
  CLEAR_SUGGESTIONS,
  EMAIL_SENT_RESET,
  GET_GROUP_EMAIL_RECIPIENTS,
  INCREMENT_EMAIL_ERROR_COUNT,
  RECEIVE_EMAIL_SUGGESTIONS,
  RECEIVE_GROUP_EMAIL_RECIPIENTS,
  SET_EMAIL_ERROR_COUNT,
  SET_EMAIL_ERROR_MESSAGE,
  SET_EMAIL_IS_GROUP_TYPE_OFF,
  SET_EMAIL_IS_GROUP_TYPE_ON,
  TOGGLE_CONFIRM_RECIPIENTS,
  TURN_OFF_ATTACHMENT_ERROR,
  TURN_OFF_CONFIRM_RECIPIENTS,
  TURN_OFF_EMAIL_SAVING,
  TURN_OFF_EMAIL_SENT,
  TURN_ON_ATTACHMENT_ERROR,
  TURN_ON_EMAIL_SAVING,
  TURN_ON_EMAIL_SENT,
  UPDATE_ATTACHMENTS,
  UPDATE_GROUP_EMAIL_TYPE,
} from "@/components/email/ducks/Actions"
import { mailMergeTypes, validTypes } from "@/components/email/helpers/EmailFunctions"

const defaultState = {
  recipientsConfirmed: false,
  emailSubject: "",
  emailBody: "",
  saving: false,
  emailSent: false,
  attachmentError: false,
  attachmentIds: [],
  emailErrorMessage: "",
  errorCount: 0,
  emailIsGroupType: true,
  loadingRecipients: false,
  hasLargeNumRecp: false,
  groupEmailType: "",
  suggestions: [],
}

const userEmailReducer = (oldState = defaultState, action) => {
  Object.freeze(oldState)
  switch (action.type) {
    case LOGOUT:
      return defaultState

    case TOGGLE_CONFIRM_RECIPIENTS:
      return {
        ...oldState,
        recipientsConfirmed: !oldState.recipientsConfirmed,
      }

    case TURN_OFF_CONFIRM_RECIPIENTS:
      return {
        ...oldState,
        recipientsConfirmed: false,
      }

    case RECEIVE_EMAIL_SUGGESTIONS:
      return {
        ...oldState,
        suggestions: action.suggestions,
      }

    case CLEAR_SUGGESTIONS:
      return {
        ...oldState,
        suggestions: [],
      }

    case TURN_ON_EMAIL_SAVING:
      return {
        ...oldState,
        saving: true,
      }

    case TURN_OFF_EMAIL_SAVING:
      return {
        ...oldState,
        saving: false,
      }

    case TURN_ON_EMAIL_SENT:
      return {
        ...oldState,
        emailSent: true,
      }

    case TURN_OFF_EMAIL_SENT:
      return {
        ...oldState,
        emailSent: false,
      }

    case CHANGE_SUBJECT:
      return {
        ...oldState,
        emailSubject: action.emailSubject,
      }

    case CHANGE_BODY:
      return {
        ...oldState,
        emailBody: action.emailBody,
      }

    case TURN_ON_ATTACHMENT_ERROR:
      return {
        ...oldState,
        attachmentError: true,
      }

    case TURN_OFF_ATTACHMENT_ERROR:
      return {
        ...oldState,
        attachmentError: false,
      }

    case UPDATE_ATTACHMENTS:
      return {
        ...oldState,
        attachmentIds: action.attachmentIds,
      }

    case SET_EMAIL_ERROR_MESSAGE:
      return {
        ...oldState,
        errorMessage: action.errorMessage,
      }

    case INCREMENT_EMAIL_ERROR_COUNT:
      return {
        ...oldState,
        errorCount: oldState.errorCount + 1,
      }

    case SET_EMAIL_ERROR_COUNT:
      return {
        ...oldState,
        errorCount: action.errorCount,
      }

    case EMAIL_SENT_RESET:
      return defaultState

    case SET_EMAIL_IS_GROUP_TYPE_OFF:
      return {
        ...defaultState,
        emailIsGroupType: false,
      }

    case SET_EMAIL_IS_GROUP_TYPE_ON:
      return {
        ...defaultState,
        emailIsGroupType: true,
      }

    case UPDATE_GROUP_EMAIL_TYPE:
      return {
        ...defaultState,
        emailIsGroupType: true,
        loadingRecipients: true,
        groupEmailType: action.params?.groupEmailType || "",
      }

    case UPDATE_ADMIN_EMAIL_TYPE:
      if (
        validTypes.includes(action.adminEmailType) ||
        mailMergeTypes.includes(action.adminEmailType)
      ) {
        return {
          ...defaultState,
          emailIsGroupType: false,
        }
      }
      return oldState

    case RECEIVE_GROUP_EMAIL_RECIPIENTS:
      return {
        ...oldState,
        recipientsResponse: action.recipientsResponse,
        loadingRecipients: false,
      }

    case GET_GROUP_EMAIL_RECIPIENTS:
      return {
        ...oldState,
        loadingRecipients: true,
        recipientsResponse: {},
      }

    default:
      return oldState
  }
}

export default userEmailReducer
